<script>
export default {
    props: {
        seeDirectoryActions: Boolean,
        mediaImportDisk: String,
        uploadUrl: String,
        mediaImportUrl: String,
    },
    data() {
        return {
            token: Scoop.csrfToken,
            maxFilesize: Scoop.uploadMaxFilesize,
            uploadFormVisible: false,
            selectedIndex: null,
            selectedDirectory: null,
        }
    },
    mounted() {
        this.initDropzone();
    },
    methods: {
        onNodeSelected(e) {
            this.selectedIndex = e.index;
            this.selectedDirectory = e.directory;
        },
        initDropzone() {
            Dropzone.options.imageUpload = {
                vm: this,
                maxFilesize: this.maxFilesize,
                timeout: 1800000,
                init: function () {
                    var uploadFiles = 0;

                    this.on("addedfile", function () {
                        this.options.vm.$emit('detected');

                        uploadFiles++;
                    });

                    this.on("complete", function () {
                        uploadFiles--;

                        if (uploadFiles === 0) {
                            window.location.href = this.options.vm.mediaImportUrl;
                        }
                    });
                }
            };
        }
    },
}
</script>

<template>
    <Lightbox
        id="media-upload-v2"
        headline="Media upload"
        class="inline"
        v-if="mediaImportDisk"
    >
            <span slot="open-template">
                <button class="btn btn-sm btn-warning">
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                    <span>Upload files</span>
                </button>
            </span>
        <div slot="body">
            <div>
                <media-directories
                    class="m-b"
                    :see-directory-actions="seeDirectoryActions"
                    :filter="{}"
                    :refresh-page="false"
                    @nodeSelected="onNodeSelected"
                ></media-directories>
            </div>

            <div v-show="selectedIndex">
                <form method="post" :action="uploadUrl"
                      accept-charset="utf-8" enctype="multipart/form-data"
                      class="dropzone" id="image-upload"
                >
                    <input type="hidden" name="uploadDisk" :value="mediaImportDisk"/>
                    <input type="hidden" name="frmMediaIndex" id="frmMediaIndex"
                           :value="selectedIndex"/>
                    <input type="hidden" name="frmMediaDirectory" id="frmMediaDirectory"
                           :value="selectedDirectory || ''"/>
                    <input type="hidden" name="_token" :value="token"/>

                    <div class="dz-message" data-dz-message>
                        <div class="text text-center">
                            <i class="fa fa-cloud-upload fa-5x" aria-hidden="true"></i>
                            <h3 v-text="__('scoop-os.common.drop_to_upload')"></h3>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </Lightbox>
</template>

<style lang="scss">
#image-upload {
    border: dashed 1px #ccc;
    height: 100%;
    line-height: 135px;

    .dz-message {
        color: #b5b5b5;
    }
}
</style>
